import { render, staticRenderFns } from "./MaterialMultiSelect.vue?vue&type=template&id=1a59e92a&scoped=true&"
import script from "./MaterialMultiSelect.vue?vue&type=script&lang=js&"
export * from "./MaterialMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./MaterialMultiSelect.vue?vue&type=style&index=1&id=1a59e92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59e92a",
  null
  
)

export default component.exports